import { combineReducers } from "redux";
import listOperation from "./listOperation";

const rootReducer = combineReducers({ listOperation });

export default rootReducer;
